import { Bars } from "react-loader-spinner";
import Loader from "./loader";
const Loading = () => {
  return (
    <>
      <Bars
        height="15px"
        radius="9"
        color="#ffffff"
        ariaLabel="loading"
        wrapperStyle
        wrapperClass
      />
    </>
  );
};

export const PageLoader = () => {
  return (
    <div className="h-screen w-full bg-[#f6f6f6]">
      <div className="flex items-center justify-center w-full h-full">
        <Loader />
      </div>
    </div>
  );
};

export default Loading;
